import script from "./ProductPreviewCom.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPreviewCom.vue?vue&type=script&setup=true&lang=js"

import "./ProductPreviewCom.vue?vue&type=style&index=0&id=564ae726&lang=css"

const __exports__ = script;

export default __exports__